<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <h5>
      Movimientos, transferencias y cashback
    </h5>
    <b-table
        sticky-header
        responsive
        show-empty
        :items.sync="movimientoService.data"
        :fields.sync="movimientoService.fieldsMovimientoTodosAceptados">
      <template #empty="scope">
        <p class="alert alert-warning"> No hay datos
        </p>
      </template>
      <template v-slot:cell(monto)="row">
        {{ row.item.aFavor === true ? row.item.monto : (row.item.monto * -1) | moneda }}
      </template>
      <template v-slot:cell(detalle)="row">
        <b-button
            v-b-modal="'detalle-'+row.item.id"
            size="sm"
            variant="info"
        >
          <font-awesome-icon
              icon="eye"
          />
        </b-button>
        <b-modal :id="'detalle-'+row.item.id" title="Detalle del movimiento">
          <p class="my-4">
            <DetalleMovimiento :fields="movimientoService.fieldsMovimientoDetalle" :movimiento="row.item"/>
          </p>
        </b-modal>
      </template>
      <template v-slot:cell(saldoTotal)="{item}">
        {{ item.saldoTotal | moneda }}
      </template>
      <template v-slot:cell(autorizaciones)="row">
        <b-button
            v-b-modal="'autorizar-'+row.item.idMovimiento"
            size="sm"
            :variant="usuarioAutorizaMovimiento(row.item.autorizaciones)? 'info':'secondary'"
        >
          <font-awesome-icon
              :icon="autorizacionesCompletas(row.item.autorizaciones) ? 'check':'eye'"
          />
        </b-button>
        <b-modal
            size="lg"
            :id="'autorizar-'+row.item.idMovimiento" title="Autorización del movimiento">
          <p class="my-4">
            <AutorizarMovimiento :autorizaciones="row.item.autorizaciones"></AutorizarMovimiento>
          </p>
        </b-modal>
      </template>
      <template v-slot:cell(pdf)="row">
        <MostrarComprobanteMovimiento v-if="row.item.fechaSolucion !== null" :id-movimiento="row.item.idMovimiento"/>
        <div v-else class="text-info">No se ha completado el proceso</div>
      </template>
      <template v-slot:cell(archivos)="row">
        <b-button
            :variant="row.item.archivos.length === 0? 'secondary':'info'"
            v-b-modal="'archivos-'+row.item.idMovimiento"
            size="sm">
          <font-awesome-icon icon="file"/>
        </b-button>
        <b-modal
            size="lg"
            :id="'archivos-'+row.item.idMovimiento" title="Archivos del movimiento">
          <p class="my-4">
            <ListarArchivos :show-delete="false" :archivos="row.item.archivos"/>
          </p>
        </b-modal>
      </template>
    </b-table>
    <br><br><br><br><br><br><br><br>
  </div>
</template>

<script>
import DetalleMovimiento from "@/views/movimientos/movimiento/DetalleMovimiento";
import AutorizarMovimiento from "@/views/movimientos/movimiento/AutorizarMovimiento";
import {MovimientoService} from "../../apiServices/movimiento/MovimientoService";
import ListarArchivos from "../../components/archivos/ListarArchivos";
import MostrarComprobanteMovimiento from "./movimiento/MostrarComprobanteMovimiento";


export default {
  name: "ListaMovimientosTodosAceptadosPorPaciente",
  components: {MostrarComprobanteMovimiento, ListarArchivos, AutorizarMovimiento, DetalleMovimiento},
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      fieldsDetalle: [],
      movimientoService: new MovimientoService(),
    }
  },
  methods: {
    obtenerDiasParaResolver({item}) {
      const dias = item.diasSolucion;
      const d1 = new Date(item.fechaAlta)
      const d2 = new Date(d1).addDays(dias)
      const d3 = new Date();
      return this.movimientoService.formatters.date.diasDiferencia(d3, d2);
    },
    usuarioAutorizaMovimiento(autorizaciones) {
      return !!autorizaciones.find(autorizacion => autorizacion.idEmpleado === this.$localStorageService.getIdEmpleado())
    },
    autorizacionesCompletas(autorizaciones) {
      return !autorizaciones.find(autorizacion => autorizacion.autorizado === false)
    }
  },
  async created() {
    this.debug = this.$localStorageService.getDebug();

    this.$root.$on('paciente', async (paciente) => {
      this.movimientoService.listarMovimientosTodosAceptados(paciente.idPaciente);
    })

  },
  computed: {
    isLoading() {
      return this.movimientoService.loading;
    }
  }
}
</script>
